import type { CreateTagPayload } from '@domain/schemas/payload.schema';
import type { CreateTagResponse } from '@responses/tags';
import axios from 'axios';

import { getRequestAuthPayload } from '../helpers/getRequestAuth';

export const createTag = async (data: CreateTagPayload): Promise<CreateTagResponse> => {
  const networkPayload = await getRequestAuthPayload({
    method: 'post',
    url: 'tags',
    data,
  });

  const response = await axios(networkPayload);
  return response.data;
};
